import Enum from './enum'

class PaymentDateChoice extends Enum
{
  constructor(value) {
    super(value);
  }
}

PaymentDateChoice.init({
  EMPTY: 'None',
  VARIANT1: 'PayDate1',
  VARIANT2: 'PayDate2'
}, {
  EMPTY: 'payment-date-choice.none',
  VARIANT1: 'payment-date-choice.variant1',
  VARIANT2: 'payment-date-choice.variant2'
}, {
  mandatory: ['VARIANT1', 'VARIANT2']
});

export default PaymentDateChoice;
